// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "2613844418f2313a8df8" + "/js/" + chunkId + ".js";
};